import { TrackingCategoryOption } from "../tracking-categories.ts/tracking-category-option";
import { TrackingCategory } from "../tracking-categories.ts/trackingCategory";

export class BookkeepingFilter {
  suppliers?: string[] = null;
  invoiceDateRange?: Date[] = null;
  invoiceDateRangeOption?: string = null;
  categories?: string[] = null;
  trackingOptions1?: string[] = null;
  trackingOptions2?: string[] = null;
  tags?: string[] = null;
  status?: boolean = false;
  accounts?: string[] = null;
  submitters?: string[] = null;
  assignedTo?: string[] = null;
  // Type filter (e.g. Supplier Invoice, Receipt)
  types?: string[] = null;
  // Amount filters
  amountMin?: number = null;
  amountMax?: number = null;
}
